import React, { useEffect } from "react";
import "./SideModalFour.css";

import largerlock from "../../images/large-lock.svg";
import bear from "../../images/bear.png";
import md1 from "../../images/modal1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function SideModalFour() {
  return (
    <div className="onemodal-cont fourmodal-cont">
      <div class="custom-box-wrapper">
        <svg
          class="custom-box-svg"
          viewBox="0 0 300 100"
          preserveAspectRatio="none"
        >
          <polygon
            points="150,0 300,10 300,90 150,100 0,90 0,10"
            fill="#dbc3dc"
            stroke="#7a4fa3"
            stroke-width="2"
            stroke-dasharray="2,2"
            vector-effect="non-scaling-stroke"
          />
        </svg>
{/* <svg 
    class="custom-box-svg custom-box-svg1" 
    viewBox="0 0 300 115" 
    preserveAspectRatio="none"
    style="filter: drop-shadow(0px 10px 15px rgba(0,0,0,0.15));"
  >
    <polygon 
      points="0,20 150,10 300,20 300,100 150,110 0,100" 
      fill="#a68ba7" 
    />
    
    <polygon 
      points="0,10 150,0 300,10 300,90 150,100 0,90" 
      fill="#dbc3dc" 
      stroke="#7a4fa3" 
      stroke-width="2" 
      stroke-dasharray="2,2" 
      vector-effect="non-scaling-stroke"
    />
    
    <polyline 
      points="2,12 150,3 298,12" 
      fill="none" 
      stroke="white" 
      stroke-width="1.5" 
      opacity="0.4"
    />
  </svg> */}



        <div class="custom-box-content">
          <h6>Access your Complete Profile</h6>
          <p>
            Unlock the full results to find out which CARTOON CHARACTER
            perfectly matches your personality archetype
          </p>
          {/* <p>Unlock the full results to find out which CARTOON CHARACTER perfectly matches your personality archetype</p>
             <p>Unlock the full results to find out which CARTOON CHARACTER perfectly matches your personality archetype</p> */}
          <button>Get Detailed Report</button>
        </div>
        <img src={bear} alt="" />
        <img src={largerlock} alt="" />
      </div>
    </div>
  );
}

export default SideModalFour;
